import { createSlice } from '@reduxjs/toolkit'
import { ENTITY_NAMES } from '../../const/api'

const initialState = {
  sortedIds: [],
  entities: {},
  filters: {},
  sorter: {},
  isLoaded: false,
  isSavingActive: false,
  search: '',
  page: 1,
  pageCount: 1,
}

const mobileAppsSlice = createSlice({
  name: 'mobileApp',
  initialState,
  reducers: {
    fetchAppVersionsSuccess: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      page: payload.page,
      pageCount: payload.pageCount,
      entities: payload.appVersions,
      sortedIds: payload.sortedIds,
    }),
    fetchMobileNotificationsSuccess: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      page: payload.page,
      pageCount: payload.pageCount,
      entities: {
        ...state.entities,
        [ENTITY_NAMES.mobileNotifications]: payload.mobileNotifications,
      },
      sortedIds: payload.sortedIds,
    }),
    fetchAppVersionsFailure: (state) => state,
    fetchMobileNotificationsFailure: (state) => state,
    resetFiltersAndSorter: (state) => ({
      ...state,
      page: initialState.page,
      filters: initialState.filters,
      sorter: initialState.sorter,
    }),
    saveFiltersAndSorter: (state, { payload = {} }) => ({
      ...state,
      search: payload.search,
      filters: payload.filters || initialState.filters,
      sorter: payload.sorter || initialState.sorter,
    }),
    startSaving: (state) => ({
      ...state,
      isSavingActive: true,
    }),
    finishSaving: (state) => ({
      ...state,
      isSavingActive: false,
    }),
  },
})

export default mobileAppsSlice
